import React, { useState } from "react";
import { apiPath } from "../utilities/Constants";
import useFetch from "../hooks/useFetch";
import GlobalForm from "../components/globalForm/GlobalForm";
import { updateData } from "../hooks/update";
import LoaderFilling from "../components/shared/Loader/LoaderFilling";
import TransportCard from "../components/shared/TransportCard";
import Swal from "sweetalert2";
import { deleteData } from "../hooks/delete";
import useSession from "../hooks/useSession";
import SearchComponent from "../components/shared/SearchComponent";

function LocalTransportListPage() {
  const { localApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(localApi);
  const [user] = useSession();
  const [filteredData, setFilteredData] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // Loading screen
  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  // destructure necessary data
  const {
    solutionTitle,
    solutionSlogan,
    solutionDetails,
    solutionLink,
    solutionImg,
    _id,
  } = apiData[0] ?? {};

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(localApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.data?._id?.length > 0;
  }

  // search handler
  function searchInputHandler(event) {
    event.preventDefault();
    const query = event.target?.value?.trim().toLowerCase();
    setSearchQuery(query);

    const queryData = [...apiData]?.filter((bus) => {
      const allRoutes = bus.stoppage.map((item) => item.name);
      const uniq = [...new Set(allRoutes)];
      const didRoutesMatchBool = uniq.map((item) => item.includes(query));
      const didRoutesMatch =
        didRoutesMatchBool?.filter((item) => item)?.length > 0;

      return (
        bus.busName?.toLowerCase()?.includes(query) ||
        didRoutesMatch ||
        bus.city?.includes(query)
      );
    });

    // save search result
    setFilteredData(queryData);
  }

  return (
    <div>
      <div className="p-2 lg:p-8 space-y-3">
        {/* search bar */}
        <div>
          <SearchComponent searchInputHandler={searchInputHandler} />
          <span className="text-right w-full block text-gray-500 dark:text-gray-300 font-medium text-sm">
            <span>
              Total Transport:{" "}
              {searchQuery?.length > 0 ? filteredData?.length : apiData?.length}
            </span>
          </span>
        </div>
        <TransportCard />
        {(searchQuery?.length > 0 ? filteredData : apiData)?.map(
          (item, key) => (
            <TransportCard
              key={key}
              project={item}
              handleSingleDelete={handleSingleDelete}
              user={user.role}
            />
          )
        )}

        {/* empty message */}
        {searchQuery?.length > 0 && filteredData?.length <= 0 && (
          <p className="text-gray-400 py-32 text-center font-medium">
            No transport matches this query.
          </p>
        )}
      </div>
    </div>
  );
}

export default LocalTransportListPage;
